import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-757c72f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "o-text-h2 mb-10" }
const _hoisted_2 = { class: "mb-40" }
const _hoisted_3 = { class: "inline-block mr-10" }
const _hoisted_4 = { class: "sm:flex sm:justify-between" }
const _hoisted_5 = { class: "w-full sm:w-1/2 sm:pr-15" }
const _hoisted_6 = { class: "w-full sm:w-1/2 sm:pl-15" }
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "mt-30 p-20 bg-wild-sand"
}
const _hoisted_12 = { class: "flex justify-center mt-40" }

import { computed, Ref, ref } from 'vue';
import { Form } from 'vee-validate';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { LinkModel, StoreModel } from '@/types/B2CcontentServerContract';
import Recaptcha, { RecaptchaComponentInstance } from '@/shared/form/recaptcha/Recaptcha.vue';
import authService from '@/b2c/shared/auth/auth.service';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import { CreateProfileResponse, CreateProfileStatus } from '@/b2c/shared/api/server-apis';
import siteContextStore from '@/shared/content/site-context.store';
import { maybeSoftRedirect } from '@/core/navigation/redirect.service';
import { QueryKeys } from '@/shared/config/route-query.config';
import InputErrorMessage from '@/shared/form/InputErrorMessage.vue';
import ProfileBirthdayInput from '@/b2c/profile/ui/ProfileBirthdayInput.vue';
import InputCheckbox from '@/shared/form/InputCheckbox.vue';
import ConfirmationButton from '@/shared/form/ConfirmationButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateProfile',
  props: {
    stores: { default: Array },
    redirectLink: { default: {
        spaLink: false,
        url: siteContextStore.settings.frontPageUrl,
    } }
  },
  setup(__props: any) {

const props = __props as { stores: StoreModel[] | [], redirectLink: LinkModel }



const labels = useBlockLabels();
const recaptcha: Ref<RecaptchaComponentInstance | null> = ref(null);
const recaptchaKey: Ref<string> = ref('');
const username: Ref<string> = ref('');
const existingUsername: Ref<string> = ref('');
const pending: Ref<boolean> = ref(false);
const createProfileWebApiMessageKey = 'createProfileApiMessages';

const loginLink: Ref<LinkModel> = computed(() => {
    return siteContextStore.settings.loginLink;
});

const verifyRecaptcha = () => {
    pending.value = true;
    recaptcha.value && recaptcha.value.reset();
    recaptcha.value && recaptcha.value.execute();
};

const submit = async({
    firstName, lastName, store, email, password, newsletter, birthdayDate, zipCode,
}): Promise<CreateProfileResponse | undefined> => {
    const params = {
        firstName,
        lastName,
        storeId: store,
        emailAddress: email,
        password,
        signUpNewsLetter: !!newsletter,
        birthday: birthdayDate ?? undefined,
        zipCode,
    };
    const response = await authService.createProfile(params, recaptchaKey.value, createProfileWebApiMessageKey);
    const createProfileStatus = response?.status ?? null;
    if (createProfileStatus === CreateProfileStatus.Success) {
        const redirectUrlWithParams = `${props.redirectLink.url}?${QueryKeys.Id}=${response?.profileRegistrationId}&${QueryKeys.Email}=${encodeURIComponent(email)}`;
        maybeSoftRedirect({
            ...props.redirectLink,
            url: redirectUrlWithParams,
        });
    } else if (createProfileStatus === CreateProfileStatus.ProfileWithThatUserNameAlreadyExist) {
        existingUsername.value = username.value;
    }
    pending.value = false;
    return response;
};

const notifyUserNameAlreadyExists: Ref<boolean> = computed(() => {
    return username.value !== '' && username.value === existingUsername.value;
});

const formValidation = {
    firstName: 'required',
    lastName: 'required',
    store: props.stores.length ? 'required' : '',
    email: 'required|email',
    password: 'required|min-password:8',
    terms: 'required',
    newsletter: 'required',
    zipCode: 'max:100',
    birthdayIsValidOrNull: 'required',
    birthDay: 'calenderDay',
    birthMonth: 'calenderMonth',
    birthYear: 'calenderYear',
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(labels).heading), 1),
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).existingProfileDescriptionText), 1),
      _createVNode(_component_RouterLinkConditional, {
        class: "inline-block c-magic-line text-dusty-grey",
        to: _unref(loginLink).url,
        "spa-enabled": _unref(loginLink).spaLink,
        title: _unref(labels).existingProfileLinkText
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(labels).existingProfileLinkText), 1)
        ]),
        _: 1
      }, 8, ["to", "spa-enabled", "title"])
    ]),
    _createVNode(_unref(Form), {
      "validation-schema": formValidation,
      onSubmit: verifyRecaptcha
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(Recaptcha, {
          ref_key: "recaptcha",
          ref: recaptcha,
          modelValue: recaptchaKey.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recaptchaKey).value = $event)),
          onVerify: ($event: any) => (handleSubmit(submit))
        }, null, 8, ["modelValue", "onVerify"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_InputText, {
              name: "firstName",
              label: _unref(labels).firstNameFieldLabel,
              autofocus: true
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_InputText, {
              name: "lastName",
              label: _unref(labels).lastNameFieldLabel
            }, null, 8, ["label"])
          ])
        ]),
        _createVNode(_component_InputText, {
          modelValue: username.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event)),
          name: "email",
          label: _unref(labels).emailFieldLabel,
          type: "email"
        }, null, 8, ["modelValue", "label"]),
        (__props.stores.length)
          ? (_openBlock(), _createBlock(_component_InputSelect, {
              key: 0,
              label: _unref(labels).storeSelectionLabel,
              name: "store"
            }, {
              default: _withCtx(() => [
                _createElementVNode("option", _hoisted_7, _toDisplayString(_unref(labels).storeSelectionOptionLabel), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stores, (store) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: store.id,
                    value: store.id
                  }, _toDisplayString(store.description), 9, _hoisted_8))
                }), 128))
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(ProfileBirthdayInput),
        _createVNode(_component_InputText, {
          key: "zipCode",
          name: "zipCode",
          label: _unref(labels).zipCodeFieldLabel,
          type: "text",
          maxlength: "100",
          "input-clear": false
        }, null, 8, ["label"]),
        _createVNode(_component_InputText, {
          key: "password",
          name: "password",
          label: _unref(labels).passwordFieldLabel,
          type: "password",
          autocomplete: "new-password",
          "input-clear": false
        }, null, 8, ["label"]),
        _createVNode(InputCheckbox, {
          name: "newsletter",
          "show-errors": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(labels).newsletterSubscriptionLabel), 1),
            _createElementVNode("div", {
              class: "mt-3 o-rte-caption",
              innerHTML: _unref(labels).newsletterSubscriptionTermsAndConditions
            }, null, 8, _hoisted_9),
            _createVNode(InputErrorMessage, {
              class: "mt-5",
              name: "newsletter"
            })
          ]),
          _: 1
        }),
        _createVNode(InputCheckbox, {
          name: "terms",
          "show-errors": false,
          class: "mt-40"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(labels).termsAndConditionsLabel), 1),
            _createElementVNode("div", {
              class: "mt-3 o-rte-caption",
              innerHTML: _unref(labels).termsAndConditions
            }, null, 8, _hoisted_10),
            _createVNode(InputErrorMessage, {
              class: "mt-5",
              name: "terms"
            })
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "o-anim-fade-300" }, {
          default: _withCtx(() => [
            (_unref(notifyUserNameAlreadyExists))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$dictionary.format(_unref(labels).createProfileUserAlreadyExists, [existingUsername.value])) + " ", 1),
                    _createVNode(_component_RouterLinkConditional, {
                      class: "inline-block c-magic-line c-magic-line--underline",
                      to: _unref(loginLink).url,
                      "spa-enabled": _unref(loginLink).spaLink,
                      title: _unref(labels).createProfileUserAlreadyExistsLinkText
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(labels).createProfileUserAlreadyExistsLinkText), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "spa-enabled", "title"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(ConfirmationButton, {
            class: "min-w-200",
            confirm: pending.value,
            text: _unref(labels).createProfileButtonText,
            "confirmation-text": _unref(labels).createProfilePendingText
          }, null, 8, ["confirm", "text", "confirmation-text"])
        ])
      ]),
      _: 1
    }),
    _createVNode(WebApiMessage, {
      id: createProfileWebApiMessageKey,
      "clear-timing": 3000,
      class: "mt-30"
    })
  ]))
}
}

})